import PropTypes from 'prop-types';

export const EventType = PropTypes.shape({
	title: PropTypes.string.isRequired,
	thumbnailFile: PropTypes.object.isRequired,
	nearestDate: PropTypes.string,
	genres: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired
		})
	),
	seancesCount: PropTypes.number,
	seanceStartDate: PropTypes.string,
	seanceEndDate: PropTypes.string,
	places: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			locale: PropTypes.shape({
				sysName: PropTypes.string
			}),
			institute: PropTypes.object
		})
	),
	isPremiere: PropTypes.bool,
	isPushkinsCard: PropTypes.bool
});

export const PublicationType = PropTypes.shape({
	title: PropTypes.string.isRequired,
	thumbnailFile: PropTypes.object.isRequired,
	publishDate: PropTypes.string
});

export const IntituteType = PropTypes.shape({
	_id: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	thumbnailFile: PropTypes.object,
	type: PropTypes.string,
	locale: PropTypes.shape({
		sysName: PropTypes.string,
		timezone: PropTypes.string,
		title: PropTypes.string,
		_id: PropTypes.number
	}),
	foundationDate: PropTypes.string
});

export default {
	event: EventType,
	publication: PublicationType,
	institute: IntituteType
};
